import React, { useState, useEffect } from "react";
import { Modal, Button, Typography } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { hideLoggedInElsewhereModal } from "../../core/data/redux/slices/LoggedInElsewhereSlice";

const { Title, Text } = Typography;

const LoggedInElsewhereModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.loggedInElsewhere.isOpen);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  // Prevent browser navigation when modal is open
  useEffect(() => {
    if (!isOpen) return;

    const handlePopState = (e) => {
      // Immediately clear storage and redirect on back/forward button
      localStorage.removeItem("userId");
      localStorage.removeItem("token");
      window.location.href = "/";
    };

    // Push initial state to prevent back navigation
    window.history.pushState(null, "", window.location.href);

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [isOpen]);

  const handleLogout = () => {
    setIsLoggingOut(true);

    // Clear storage and redirect
    localStorage.removeItem("userId");
    localStorage.removeItem("token");

    // Hide modal
    dispatch(hideLoggedInElsewhereModal());

    // Small delay to show loading state
    setTimeout(() => {
      window.location.href = "/";
    }, 500);
  };

  return (
    <Modal
      open={isOpen}
      closable={true}
      maskClosable={true}
      keyboard={true}
      onCancel={handleLogout}
      onOk={handleLogout}
      centered
      width={500}
      footer={[
        <Button
          key="logout"
          type="primary"
          size="large"
          onClick={handleLogout}
          loading={isLoggingOut}
          block
          danger
        >
          {isLoggingOut ? "Logging out..." : "Go to Login"}
        </Button>,
      ]}
      // Ensure modal stays on top and blocks all interaction
      zIndex={9999}
    >
      <div style={{ textAlign: "center", padding: "20px 0" }}>
        <WarningOutlined
          style={{
            fontSize: "64px",
            color: "#ff4d4f",
            marginBottom: "20px",
          }}
        />

        <Title level={3} style={{ marginBottom: "16px", color: "#ff4d4f" }}>
          Session Expired
        </Title>

        <Text
          style={{
            display: "block",
            fontSize: "16px",
            marginBottom: "8px",
            color: "#595959",
          }}
        >
          You have been logged in from another device or browser.
        </Text>

        <Text
          style={{
            display: "block",
            fontSize: "14px",
            color: "#8c8c8c",
          }}
        >
          Please log in again to continue using the application.
        </Text>
      </div>
    </Modal>
  );
};

export default LoggedInElsewhereModal;
